export default "__VITE_ASSET__c5c8a859__"